<template>
  <div class="account" v-loading="loading">
    <!-- <div class="header">
            <p>成员信息</p>
        </div> -->
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <el-table
          :data="accountList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="nickname" label="昵称"> </el-table-column>
          <el-table-column prop="username" label="账号"> </el-table-column>
          <el-table-column prop="phone" label="手机号"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'account',
  data: function () {
    return {
      editName: '', // 编辑的哪个权限组名称
      loading: false, // 加载
      accountList: [], // 用户账号列表
      title: {
        // 页面标题
        firstTitile: '基础设置',
        secondTitle: '权限管理'
      }
    };
  },
  mounted() {
    this.editName = this.$route.query.groupName;
    // 获取成员列表
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.loading = true;
      this.httpGet(this.$root.powerGroupMember, {
        group: this.editName
      }).then(
        (res) => {
          this.accountList = res.list;
          this.totalSize = res.total;
          this.loading = false;
        },
        (res) => {
          this.$message.error(res);
        }
      );
    },
    // 单元格斑马样式添加类名
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'striped striped-even';
      } else {
        return 'striped striped-odd';
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.el-dialog__wrapper .el-input {
  width: 240px !important;
}

.account {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px;
      border-radius: 2px;

      .screen {
        width: calc(100% - 30px);
        background: bk;
        padding: margin10;
        flex-x(flex-start);
        margin-top: margin10;

        .el-select {
          margin-right: 10px;
          width: input100;
        }

        .el-input {
          width: input200;
          margin: 0 margin10;
        }

        p {
          word(14px, gray6);
        }
      }

      .el-table {
        width: calc(100% - 10px) !important;
        margin-top: 10px;
        font-size: 12px;
        border();

        p {
          float: left;
        }

        img {
          width: 60px;
          height: 60px;
        }

        .el-icon-star-on {
          color: yellow;
        }

        .highLight {
          color: blue;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .footer {
        width: calc(100% - 30px);
        min-width: 600px;
        padding: 10px 0 0 15px;
        flex-x();

        .el-button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
